import React, { Component } from 'react';
import './App.css';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import MainPage from "./MainPage";
import DetailPage from "./DetailPage";
import JoinPage from "./JoinPage";
import Gateway from "./Gateway";
import LoginPanel from "./LoginPanel";
import TicketPanel from "./TicketPanel";
import ScrollTop from "./ScrollTop";
const ROUTE_ROOTPATH ="(/activity)?/";  // 本地是根目录，兼容服务器上带前缀目录

class App extends Component {

  static gw = new Gateway();



  render() {
    return (
      <div className="App">
        <Switch>
          <Route path={ROUTE_ROOTPATH+"join-:id"}   component={JoinPage} />
          <Route path={ROUTE_ROOTPATH+"detail-:id"}   component={DetailPage} />
          <Route path={ROUTE_ROOTPATH}   component={MainPage} />
        </Switch>

        <LoginPanel/>
        <TicketPanel/>
      </div>
    );
  }
}

export default App;
